import React, { useEffect } from "react";

// Layout Related Components
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
// import Footer from "./Footer";

//redux
import { useSelector, useDispatch } from "react-redux";

const Layout = (props: any) => {

    return (
        <div className="app app-header-fixed app-sidebar-fixed app-with-dark-sidebar">
            <Sidebar />
            <Header />
            <div id="mainappcontent" className="app-content">
                {props.children}
            </div>
        </div>
    )
}

export default Layout;